import api from './api';

const dashboardService = {
    getStats: async () => (await api.get('/admin/dashboard/stats')).data,
};

export default dashboardService;
